import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./utils/ProtectedRoute";

import "./styles/app.css";

// PAGES
// import Dashboard from "./pages/Dashboard";
import Login from "./Pages/Common/LoginPage";
import Register from "./Pages/Partner/Register";
import ResetPassword from "./Pages/Partner/ResetPassword";
// import LoginSelector from "./Pages/LoginSelector";
import SupportLogin from "./Pages/Support/SupportLoginPage";
import PartnerLogin from "./Pages/Partner/PartnerLoginPage";
import { useDispatch, useSelector } from "react-redux";
import Home from "./Pages/Common/Home";
import Users from "./Pages/Common/Users";
import AddFarmer from "./Pages/Common/AddFarmer";
import BulkOnboardFarmers from "./Pages/Common/BulkOnboardFarmers";
import BookTest from "./Pages/Common/BookTest";
import PermissionRoute from "./utils/permissionRoute";
import UserUpdatePartner from "./Pages/Common/UserUpdatePartner";
import UserProfile from "./Pages/Support/UserProfile";
import UserBookings from "./Pages/Common/UserBookings";
import UserFarms from "./Pages/Common/UserFarm";
import AddPractice from "./Pages/Common/AddPractice";
import ListPractice from "./Pages/Common/ListPractice";
import ViewPractice from "./Pages/Common/ViewPractice";
import UserReports from "./Pages/Common/UserReports";
import ViewReport from "./Pages/Support/ViewReport";
import FieldOfficers from "./Pages/Common/FieldOfficers";
import AddFieldOfficer from "./Pages/Partner/AddFieldOfficer";
import FieldOfficerProfile from "./Pages/Common/FieldOfficerProfile";
import FieldOfficerFarmers from "./Pages/Support/FieldOfficerFarmers";
import FieldOfficerSamples from "./Pages/Partner/FieldOfficerSamples/FieldOfficerSamples";
import FieldOfficerReports from "./Pages/Partner/FieldOfficerReports/FieldOfficerReports";
import Reports from "./Pages/Common/Reports";
import CreateReport from "./Pages/Support/CreateReport";
import UpdateReport from "./Pages/Support/UpdateReport";
import DownloadReports from "./Pages/Support/DownloadReports";
import ViewLogs from "./Pages/Support/ViewLogs";
import SoilAnomalyLogs from "./Pages/Support/SoilAnomalyLogs";
import CreateFarm from "./Pages/Common/CreateFarm";
import Bookings from "./Pages/Common/Bookings";
import Profile from "./Pages/Common/Profile";
import PartnerProfile from "./Pages/Partner/PartnerProfile";
import Partners from "./Pages/Support/Partners";
import AddPartner from "./Pages/Support/AddPartner";
import FieldOfficerOFPartner from "./Pages/Support/FieldOfficerOFPartner";
import Device from "./Pages/Common/Device";
import DeviceDetail from "./Pages/Common/DeviceDetail";
import DeviceHardwareVersion from "./Pages/Support/DeviceHardwareVersion";
import DeviceSoftwareVersion from "./Pages/Support/DeviceSoftwareVersion";
import Export from "./Pages/Common/Export";
import Inquiries from "./Pages/Support/Inquiries";
import RecommendationCrops from "./Pages/Recommendations/RecommendationCrops";
import RecommendationCropDetail from "./Pages/Recommendations/RecommendationCropDetail";
import { fetchRole, selectRoleLoading, setGuestMode } from "./store/features/roleSlice";
import { Spinner } from "react-bootstrap";
import SoilHealthOverviewDashboard from "./Pages/Partner/Soil_health_overview_dashboard";
import SupportProfile from "./Pages/Support/SupportProfile";
import ParameterFormula from "./Pages/Support/ParameterFormula";
import NutrientCalculator from "./Pages/Support/NutrientCalculator";
import LabDashboardPage from "./Pages/Support/LabManagement/LabDashboardPage";
import LabPerformancePage from "./Pages/Support/LabManagement/PerformancePage";
import ReagentsPage from "./Pages/Support/LabManagement/ReagentsPage";
import StockPage from "./Pages/Support/LabManagement/StockPage";
import CalculatorPage from "./Pages/Support/LabManagement/CalculatorPage";
import RawChemicalsPage from "./Pages/Support/LabManagement/RawChemicalsPage";
import OrdersPage from "./Pages/Support/LabManagement/OrdersPage";
import TestCapacityPage from "./Pages/Support/LabManagement/TestCapacityPage";
import LabReportsPage from "./Pages/Support/LabManagement/LabReportsPage";
import AuditLogPage from "./Pages/Support/LabManagement/AuditLogPage";
import CrewPage from "./Pages/Support/LabManagement/CrewPage";
import WorkLogsPage from "./Pages/Support/LabManagement/WorkLogsPage";
import TargetsPage from "./Pages/Support/LabManagement/TargetsPage";
import TaskHoursPage from "./Pages/Support/LabManagement/TaskHoursPage";
import AllFarmsMap from "./Pages/Support/AllFarmsMap";
import MapDevices from "./Pages/Support/MapDevices";
import ElectronicComponentsPage from "./Pages/Support/LabManagement/ElectronicComponents";
import HardwarePage from "./Pages/Support/LabManagement/Hardware";
import HardwareOrdersPage from "./Pages/Support/LabManagement/HardwareOrders";
import HardwareCapacityPage from "./Pages/Support/LabManagement/HardwareCapacity";
import ApiAnalyticsDashboard from "./Pages/Support/ApiAnalyticsDashboard";
import FeatureFlags from "./Pages/Support/FeatureFlags";
import RaiseIssue from "./Pages/Field_Officer/RaiseIssue";
import IssueManagement from "./Pages/Support/IssueManagement";
import ViewEditBooking from "./Pages/Common/ViewEditBooking";
import ViewBooking from "./Pages/Common/ViewBooking";
import ConsolidatedFollowUpView from "./Pages/Common/FollowUpFormView";
import PartnerDashboardSummary from "./Pages/Support/PartnerDashboardSummary";
import BulkUpdateReports from "./Pages/Support/BulkUpdateReports";
import Farms from "./Pages/Common/Farms";
import FarmSatellitePage from "./Pages/Support/FarmSatellite/FarmSatellitePage";
import Clinics from "./Pages/Common/Clinics";
import AddClinic from "./Pages/Support/AddClinic";
import EditClinic from "./Pages/Common/EditClinic";
import ProductOrdersPage from "./Pages/Common/ProductOrders";
import AddProductPage from "./Pages/Common/AddProduct";
import ProductListPage from "./Pages/Common/ProductListPage";
import CsrOverview from "./Pages/Csr/CsrOverview";
import CsrFarmers from "./Pages/Csr/CsrFarmers";
import CsrRoute from "./utils/CsrRoute";

const PUBLIC_ROUTES = [
  "/login",            
  "/partner/register",      
  "/partner/reset-password", 
  "/public/reports",         
];

const App = () => {

  const dispatch = useDispatch();
  const isLoading = useSelector(selectRoleLoading);

  useEffect(() => {
    const currentPath = window.location.pathname;
    const isPublicRoute = PUBLIC_ROUTES.some(route => currentPath.startsWith(route));
    if (isPublicRoute) {
      dispatch(setGuestMode());
    } else {
      dispatch(fetchRole());
    }
  }, [dispatch]);

  const partnerStatus = useSelector((state) => state.partner?.status);
  const supportStatus = useSelector((state) => state.support?.loginStatus);
  const fieldOfficerStatus = useSelector((state) => state.fieldOfficer?.isLoggedIn);
  const farmerStatus = useSelector((state) => state.farmer?.isLoggedIn);

  const isAuthenticated =
    partnerStatus === "succeeded" ||
    supportStatus === "succeeded" ||
    fieldOfficerStatus === true ||
    farmerStatus === true

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <Routes>
      {/* PUBLIC */}
      <Route path="/login" element={<Login />} />
      {/* <Route path="/login/partner" element={<PartnerLogin />} />
      <Route path="/login/support" element={<SupportLogin />} /> */}

      {/* Partner PUBLIC (allowed without login) */}
      <Route path="/partner/register" element={<Register />} />
      <Route path="/partner/reset-password" element={<ResetPassword />} />

      <Route path="/public/reports/:id" element={<ViewReport isPublic={true} />} />

      {/* PROTECTED */}
      <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
        <Route path="/" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/partner/profile" element={<PartnerProfile />} />
        <Route path="/partner/profile/:id" element={<PartnerProfile />} />
        <Route path="/operations/profile" element={<SupportProfile />} />
        <Route path="/partner/dashboard-summary/:admin_id" element={<PartnerDashboardSummary/>} />

        <Route element={<PermissionRoute permission="sidebar:bulk_onboard" />}>
          <Route path="/bulk-onboard" element={<BulkOnboardFarmers />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:dashboard" />}>
          <Route path="/partner/dashboard" element={<SoilHealthOverviewDashboard />} />
        </Route>

        <Route element={<CsrRoute />}>
          <Route path="/csr/overview" element={<CsrOverview />} />
          <Route path="/csr/farmers" element={<CsrFarmers />} />
        </Route>
        <Route element={<CsrRoute support />}>
          <Route path="/csr/overview/:adminId" element={<CsrOverview />} />
          <Route path="/csr/farmers/:adminId" element={<CsrFarmers />} />
        </Route>

        <Route path="/users" element={<Users />} />
        <Route path="/users/add-farmer" element={<AddFarmer />} />
        <Route path="/users/booking/:id" element={<BookTest />} />
        <Route element={<PermissionRoute permission="farmers:view" />}>
          <Route path="/users/:id" element={<UserProfile />} />
          <Route path="/users/bookings/:id" element={<UserBookings />} />
          <Route path="/users/farms/:id" element={<UserFarms />} />
          <Route path="/users/reports/:id" element={<UserReports />} />
          <Route path="/users/report/:id" element={<ViewReport isPublic={false}/>} />

          {/* user practice routes */}
          <Route path='/user/practice/add/:id' element={<AddPractice />} />
          <Route path='/user/:id/practice/list' element={<ListPractice />} />
          <Route path='/farmer/practice/:practiceId' element={<ViewPractice />} />

        </Route>

        <Route element={<PermissionRoute permission="sidebar:farms" />}>
          <Route path="/farms" element={<Farms />} />
        </Route>

        <Route element={<PermissionRoute permission="farms:satellite" />}>
          <Route path="/farms/:farmId/satellite" element={<FarmSatellitePage />} />
        </Route>

        <Route element={<PermissionRoute permission="farmers:update" />}>
          <Route path="/users/update-data/:id" element={<UserUpdatePartner />} />
        </Route>

        <Route element={<PermissionRoute permission="fieldOfficers:view" />}>
          <Route path="/field-officers" element={<FieldOfficers />} />
        </Route>
        <Route path="/field-officers/:id" element={<FieldOfficerProfile />} />
        <Route path="/add-field-officer" element={<AddFieldOfficer />} />

        <Route element={<PermissionRoute permission="fieldOfficers:farmers" />}>
          <Route path="/field-officers/:id/farmers" element={<FieldOfficerFarmers />} />
        </Route>

        <Route element={<PermissionRoute permission="fieldOfficers:reports" />}>
          <Route path="/field-officer/reports/:id" element={<FieldOfficerReports />} />
          <Route path="/admin/report/:id" element={<ViewReport />} />
        </Route>
        <Route element={<PermissionRoute permission="fieldOfficers:samples" />}>
          <Route path="/field-officer/samples/:id" element={<FieldOfficerSamples />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:partners" />}>
          <Route path="/partners" element={<Partners />} />
          <Route path="/partners/:admin_id" element={<FieldOfficerOFPartner />} />
          <Route path="/partner/add-partner" element={<AddPartner />} />
          <Route path="/partner/inquiry" element={<Inquiries />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:reports" />}>
          <Route path="/reports" element={<Reports />} />
        </Route>

        <Route element={<PermissionRoute permission="reports:view" />}>
          <Route path="/reports/:id" element={<ViewReport />} />
        </Route>

        <Route element={<PermissionRoute permission="reports:followup" />}>
          <Route path="/reports/:reportId/follow-ups" element={<ConsolidatedFollowUpView />} />
        </Route>

        <Route element={<PermissionRoute permission="reports:create" />}>
          <Route path="/create-report" element={<CreateReport />} />
        </Route>

        <Route element={<PermissionRoute permission="reports:update" />}>
          <Route path="/update-report" element={<UpdateReport />} />
        </Route>

        <Route element={<PermissionRoute permission="reports:bulk_update" />}>
          <Route path="/bulk-update-report" element={<BulkUpdateReports />} />
        </Route>

        <Route element={<PermissionRoute permission="reports:download" />}>
          <Route path="/download-report" element={<DownloadReports />} />
        </Route>

        <Route element={<PermissionRoute permission="farms:add" />}>
          <Route path='/farmers/create-farms/:id' element={<CreateFarm />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:bookings" />}>
          <Route path='/bookings' element={<Bookings />} />
          <Route path="/bookings/view/:booking_id" element={<ViewBooking />} />
          <Route path="/bookings/edit/:booking_id" element={<ViewEditBooking />} />
        </Route>

        <Route element={<PermissionRoute permission="bookings:book" />}>
          <Route path='/book-test' element={<BookTest />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:logs" />}>
          <Route path="/data-logs" element={<ViewLogs />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:anomaly_logs" />}>
          <Route path="/anomaly-logs" element={<SoilAnomalyLogs />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:lab_dashboard" />}>
          <Route path="/lab/dashboard" element={<LabDashboardPage />} />
        </Route>
        <Route element={<PermissionRoute permission="sidebar:lab_performance" />}>
          <Route path="/lab/performance" element={<LabPerformancePage />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:reagents" />}>
          <Route path="/lab/reagents" element={<ReagentsPage />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:stock" />}>
          <Route path="/lab/stock" element={<StockPage />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:calculator" />}>
          <Route path="/lab/calculator" element={<CalculatorPage />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:raw_chemicals" />}>
          <Route path="/lab/raw-chemicals" element={<RawChemicalsPage />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:orders" />}>
          <Route path="/lab/orders" element={<OrdersPage />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:test_capacity" />}>
          <Route path="/lab/test-capacity" element={<TestCapacityPage />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:lab_reports" />}>
          <Route path="/lab/reports" element={<LabReportsPage />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:audit_log" />}>
          <Route path="/lab/audit-log" element={<AuditLogPage />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:lab_crew" />}>
          <Route path="/lab/crew" element={<CrewPage />} />
        </Route>
        <Route element={<PermissionRoute permission="sidebar:lab_work_logs" />}>
          <Route path="/lab/work-logs" element={<WorkLogsPage />} />
        </Route>
        <Route element={<PermissionRoute permission="sidebar:lab_targets" />}>
          <Route path="/lab/targets" element={<TargetsPage />} />
        </Route>
        <Route element={<PermissionRoute permission="sidebar:lab_task_hours" />}>
          <Route path="/lab/task-hours" element={<TaskHoursPage />} />
        </Route>
        <Route element={<PermissionRoute permission="sidebar:electronic-components" />}>
          <Route path="/lab/electronic-components" element={<ElectronicComponentsPage />} />
        </Route>
        <Route element={<PermissionRoute permission="sidebar:hardware" />}>
          <Route path="/lab/hardware" element={<HardwarePage />} />
        </Route>
        <Route element={<PermissionRoute permission="sidebar:hardware-order" />}>
          <Route path="/lab/hardware-order" element={<HardwareOrdersPage />} />
        </Route>
        <Route element={<PermissionRoute permission="sidebar:hardware-capacity" />}>
          <Route path="/lab/hardware-capacity" element={<HardwareCapacityPage />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:export" />}>
          <Route path="/export" element={<Export />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:device_hw_version" />}>
          <Route path="/device/hardware-version" element={<DeviceHardwareVersion />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:device_sw_version" />}>
          <Route path="/device/software-version" element={<DeviceSoftwareVersion />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:device" />}>
          <Route path="/device" element={<Device />} />
          <Route path="/device/:deviceId" element={<DeviceDetail />} />
        </Route>

        <Route element={<PermissionRoute permission="recommendations:view" />}>
          <Route path="/recommendations" element={<RecommendationCrops />} />
          <Route path="/recommendations/:slug/view" element={<RecommendationCropDetail />} />
          <Route path="/recommendations/:slug" element={<RecommendationCropDetail />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:Parameter-Formula" />}>
          <Route path="/parameter-formula" element={<ParameterFormula />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:nutrient_calculator" />}>
          <Route path="/nutrient-calculator" element={<NutrientCalculator />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:farms_map" />}>
          <Route path="/support/farms-map" element={<AllFarmsMap />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:map_devices" />}>
          <Route path="/support/map-devices" element={<MapDevices />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:it_logs_group" />}>
          <Route path="/api-analytics/dashboard" element={<ApiAnalyticsDashboard />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:it_logs_group" />}>
          <Route path="/feature-flags" element={<FeatureFlags />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:raise_issue" />}>
          <Route path="/raise-issue" element={<RaiseIssue />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:issue_management" />}>
          <Route path="/support/issues" element={<IssueManagement />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:clinics" />}>
          <Route path="/clinics" element={<Clinics />} />
          <Route path="/clinics/edit/:id" element={<EditClinic />} />
        </Route>

        <Route element={<PermissionRoute permission="clinics:add" />}>
          <Route path="/clinics/add" element={<AddClinic />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:product_list" />}>
          <Route path="/products" element={<ProductListPage />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:add_product" />}>
          <Route path="/add-product" element={<AddProductPage />} />
        </Route>

        <Route element={<PermissionRoute permission="sidebar:product_orders" />}>
          <Route path="/product-orders" element={<ProductOrdersPage />} />
        </Route>

      </Route>

    </Routes>
  );
};

export default App;
